// src/components/Footer.tsx
import { Layout, Row, Col, Typography, Space, Divider } from 'antd';
import { LinkedinOutlined, MailOutlined, EnvironmentOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const { Footer: AntFooter } = Layout;
const { Title, Paragraph, Link } = Typography;

const Footer = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <AntFooter className="site-footer">
      <div className="footer-container">
        <Row gutter={[48, 32]}>
          <Col xs={24} sm={12} lg={6}>
            <div className="footer-section">
              <Title level={4} className="footer-title">
                Ailicorn
              </Title>
              <Paragraph className="footer-description">
                {t('footer.description')}
              </Paragraph>
            </div>
          </Col>

          <Col xs={24} sm={12} lg={6}>
            <div className="footer-section">
              <Title level={5} className="footer-heading">{t('footer.sections.about.title')}</Title>
              <Space direction="vertical" size="small">
                <Link onClick={() => navigate('/team')} className="footer-link">{t('footer.sections.about.team')}</Link>
              </Space>
            </div>
          </Col>

          <Col xs={24} sm={12} lg={6}>
            <div className="footer-section">
              <Title level={5} className="footer-heading">{t('footer.sections.contact.title')}</Title>
              <Space direction="vertical" size="small">
                <div className="contact-item" style={{ marginTop: '8px' }}>
                  <Link onClick={() => navigate('/contact')} className="footer-link" style={{ cursor: 'pointer' }}>
                    {t('footer.sections.contact.contactUs')}
                  </Link>
                </div>
                <div className="contact-item">
                  <MailOutlined />
                  <Link href="mailto:service@ailicorn.com" className="footer-link">
                    {t('footer.sections.contact.email')}
                  </Link>
                </div>
                <div className="contact-item">
                  <EnvironmentOutlined />
                  <span className="footer-text">{t('footer.sections.contact.address')}</span>
                </div>

              </Space>
            </div>
          </Col>
        </Row>

        <Divider className="footer-divider" />

        <Row justify="space-between" align="middle" className="footer-bottom">
          <Col xs={24} md={12}>
            <Paragraph className="copyright">
              {t('footer.copyright')}
            </Paragraph>
          </Col>
          <Col xs={24} md={12} className="social-links">
            <Space size="large">
              <Link
                href="https://www.linkedin.com/company/ailicorn-inc"
                target="_blank"
                className="social-link"
              >
                <LinkedinOutlined style={{ fontSize: '24px' }} />
              </Link>
              <Link
                href="mailto:service@ailicorn.com"
                className="social-link"
              >
                <MailOutlined style={{ fontSize: '24px' }} />
              </Link>
            </Space>
          </Col>
        </Row>
      </div>
    </AntFooter>
  );
};

export default Footer;
